import React, { useRef } from "react";
import { normalPriceCalc, normalPriceCount } from "../../env";
const ITEMS_PER_PAGE = 9;

function paginate(array, pageSize) {
  return array.reduce((acc, _, i) => {
    if (i % pageSize === 0) acc.push(array.slice(i, i + pageSize));
    return acc;
  }, []);
}
function OfficialPrintNew(props) {
  const data = props.content;
  const content = props.content.data;
  const sale = props.content.saleItems;
  const buy = props.content.purchaseItems;
  const TransData = props.content.transactions;
  const Total = props.content.calcFaktor;
  const user = props.user;
  const date = new Date(data.date);
  const printRef = useRef();
  const pages = paginate(content, ITEMS_PER_PAGE);

  return (
    <div className="zar-print" ref={printRef}>
      {pages.map((pageData, pageIndex) => (
        <React.Fragment key={pageIndex}>
          <div className="header">
            {/* <p className="center-title">به نام خالق زیبایی</p> */}
            <img
              src="/nast.png"
              className="center-title"
              style={{ width: "100px", top: "30%" }}
            />
            <div className="image-wrapper"></div>
            <div className="info-wrapper col4">
              <div className="container">
                <div className="date">
                  <p>تاریخ:</p>
                  <p>{date.toLocaleDateString("fa")}</p>
                </div>
                <div className="number number-td">
                  <p>شماره سند:</p>
                  <p>{data.ShFaktor}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="user-info number-td">
            مشتری گرامی:
            <p>
              {user.prefix && user.prefix}
              {" " + user.username}
            </p>
            <p>
              <span>کد:</span>
              {user.cCode}
            </p>
            <p>{user.phone}</p>
          </div>

          <div className="main">
            <table>
              <thead>
                <tr>
                  <th className="xsmall-td">ردیف</th>
                  <th className="larg-td">شرح</th>
                  <th className="xsmall-td">عیار</th>
                  <th className="small-td">وزن 750</th>
                  <th className="small-td">وزن</th>
                  <th className="larg-td">مبلغ(ریال)</th>
                </tr>
              </thead>
              {pageData && (
                <tbody className="sale-table">
                  {pageData.map((Item, i) => (
                    <tr
                      key={i}
                      className={`sale-tr number-td ${
                        Item.borderBottom ? "border-bottom" : ""
                      } ${Item.borderTop ? "border-top" : ""}`}
                    >
                      <td className="xsmall-td">{Item.index}</td>
                      <td className="larg-td">
                        <span>{Item.title}</span>

                        {Item.totalSale ? <br /> : <></>}
                        {!Item.isShemsh && Item.sub ? (
                          <span
                            className={Item.totalSale ? "taxtText" : ""}
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {" [" + Item.sub + "]"}
                          </span>
                        ) : (
                          <></>
                        )}
                        {Item.isShemsh ? (
                          <span
                            className={Item.totalSale ? "taxtText" : ""}
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {" [" + "تعداد:" + Item.count + "]"}
                          </span>
                        ) : (
                          <></>
                        )}
                        <span>{Item.isReturn ? " [مرجوع شده]" : ""}</span>
                      </td>
                      <td className="xsmall-td">{Item.ayar}</td>
                      <td className="small-td">{Item.weight750}</td>
                      <td className="small-td">
                        {Item?.isSang ? Item?.weight : Item?.totalWeight}
                      </td>

                      <td className="larg-td">
                        {normalPriceCount(Item.fullPrice)}
                      </td>
                    </tr>
                  ))}
                  {/* <tr className="sale-tr-total number-td">
                    <td className="xsmall-td"></td>

                    <td className="larg-td">
                      <p className="tax-p">
                        <span>مجموع کل اجناس</span>
                        {Total.totalTax ? (
                          <span>
                            {"[+9% مالیات بر ارزش افزوده" +
                              "(" +
                              normalPriceCount(Total.totalTax) +
                              ")]"}
                          </span>
                        ) : (
                          <></>
                        )}
                      </p>
                    </td>
                    <td className="xsmall-td"></td>
                    <td className="small-td">{Total.total750}</td>
                    <td className="small-td">{Total.totalSaleWeight}</td>

                    <td className="larg-td">
                      {normalPriceCount(Total.totalSale)}
                    </td>
                  </tr> */}
                </tbody>
              )}
              {/* {buy && buy.data && (
                <tbody className="buy-table">
                  {buy.data.map((Item, i) => (
                    <tr key={i} className="buy-tr number-td">
                      <td className="xsmall-td">{Item.index}</td>
                      <td className="larg-td">
                        {Item.title}
                        {Item.count && "(تعداد:" + Item.count + ")"}
                      </td>
                      <td className="xsmall-td">{Item.ayar}</td>
                      <td className="small-td">{Item.weight750}</td>
                      <td className="small-td">{Item.weight}</td>

                      <td className="larg-td">
                        {normalPriceCount(Item.fullPrice)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
              {TransData && (
                <tbody className="buy-table">
                  {TransData.map((Item, i) => (
                    <tr key={i} className="buy-tr number-td">
                      <td className="xsmall-td"></td>
                      <td className="larg-td">واریز به بانک</td>
                      <td className="xsmall-td"></td>
                      <td className="small-td"></td>
                      <td className="small-td"></td>

                      <td className="larg-td">
                        {normalPriceCount(Item.payValue)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
              <tbody className="buy-table">
                {Total.totalDiscount ? (
                  <tr className="add-tr number-td">
                    <td className="xsmall-td"></td>
                    <td className="larg-td">تخفیف</td>
                    <td className="xsmall-td"></td>
                    <td className="small-td"></td>
                    <td className="small-td"></td>

                    <td className="larg-td">
                      {normalPriceCount(Total.totalDiscount)}
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
                {Total.totalDebit ? (
                  <tr className="add-tr number-td">
                    <td className="xsmall-td"></td>
                    <td className="larg-td">بدهی</td>
                    <td className="xsmall-td"></td>
                    <td className="small-td"></td>
                    <td className="small-td"></td>

                    <td className="larg-td">
                      {normalPriceCount(Total.totalDebit)}
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
              </tbody> */}
            </table>
            <table className="more-info">
              <tr className="number-td">
                <td className="zar-box first-box">
                  <p className="title">مانده این سند:</p>
                </td>
                <td className="zar-box">
                  <p></p>
                </td>
                <td className="zar-box">
                  <p style={{ direction: "ltr" }}>
                    {Total.totalRemain
                      ? normalPriceCount(Total.totalRemain)
                      : "0"}
                  </p>
                </td>
              </tr>
            </table>
            <div className="gold-info">
              <div className="zar-box gold-day">
                <div className="zar-box-item number-td">
                  <p>یک گرم طلا 18 عیار بدون اجرت:</p>
                  <p>{normalPriceCount(data.unitPrice)}</p>
                </div>
                <div className="zar-box-item number-td">
                  <p>یک مثقال طلا:</p>
                  <p></p>
                </div>
              </div>
              <div className="zar-box history number-td">
                <div className="zar-box-item">
                  <div className="content title">
                    <p>قبل:</p>
                  </div>
                  <div className="content">
                    <p>--------</p>
                  </div>
                  <div className="content">
                    <p>--------</p>
                  </div>
                </div>
                <div className="zar-box-item">
                  <div className="content title">
                    <p>نهایی:</p>
                  </div>
                  <div className="content">
                    <p>--------</p>
                  </div>
                  <div className="content">
                    <p>--------</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <div className="title">اشتباه از طرفین قابل برگشت هست</div>
            <div className="container">
              <div className="item sign-item">
                <p>
                  صادرکننده{" "}
                  <span style={{ fontWeight: "600" }}>
                    {props.content?.manager?.username}
                  </span>
                </p>
              </div>
              <div className="item ">
                <p>Tel: 021 916 915 19</p>
                <p>Instagram: BarzegarGold</p>
                <p>WhatsApp: 09103186010</p>
              </div>
              <div className="item sign-item">
                <p>تحویل گیرنده اصلی</p>
              </div>
            </div>
          </div>
          <button className="print-btn noprint" onClick={() => window.print()}>
            چاپ
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}

export default OfficialPrintNew;
